import { Route } from 'react-router-dom';
import RouteWithProfileCheck from '../components/RouteWithProfileCheck';
import Packages from '../pages/Packages';
import PackageDetail from '../pages/PackageDetail';
import ExpectedPackages from '../pages/ExpectedPackages';
import ConsolidatePackages from '../pages/ConsolidatePackages';

export const PackageRoutes = () => (
    <>
        <Route path="expected" element={<ExpectedPackages />} />
        <Route path="packages" element={<Packages />} />
        <Route path="packages/:id" element={
            <RouteWithProfileCheck>
                <PackageDetail />
            </RouteWithProfileCheck>
        } />
        <Route path="consolidate" element={
            <RouteWithProfileCheck>
                <ConsolidatePackages />
            </RouteWithProfileCheck>
        } />
    </>
);
